// extracted by css-extract-rspack-plugin
export default {"customScrollbar":"customScrollbar-YMuRJ9","dashboardGrid":"dashboardGrid-OLWFFK"};